<template>
  <v-dialog
    v-model="dialog"
    max-width="750px"
  >
    <v-card>
      <v-card-title primary-title>
        <v-layout wrap>
          <v-flex xs10>
            <v-layout>
              <h2 class="display-3 display-3_dark mb-0">
                {{ title }}
              </h2>
            </v-layout>
          </v-flex>
          <v-flex xs2>
            <v-layout
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedProvinceId"
          append-icon="expand_more"
          item-value="province_id"
          :label="$t('label.province')"
          :items="provinces"
          :disabled="provinces.length === 1"
          :filter="filteredLocations"
        >
          <template
            slot="item"
            slot-scope="props"
          >
            <span>{{ props.item.name }}</span>
          </template>
          <template
            slot="selection"
            slot-scope="props"
          >
            {{ props.item.name }}
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-if="warehouseType === 1"
          v-model="selectedRejon"
          append-icon="expand_more"
          item-value="item"
          :label="$t('label.area')"
          :items="rejons"
          class="mt-3"
          :disabled="selectedProvinceId === null"
          :filter="filteredLocations"
        >
          <template
            slot="item"
            slot-scope="props"
          >
            <span>{{ props.item.name }}</span>
          </template>
          <template
            slot="selection"
            slot-scope="props"
          >
            {{ props.item.name }}
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[$vuetify.breakpoint.xs ? 'mt-2' : 'mr-3']"
          >
            <v-btn
              flat
              class="text-none"
              color="sz_violet"
              @click="closeDialog()"
            >
              <v-icon>chevron_left</v-icon>
              {{ $t('warehouses.buttons.back') }}
            </v-btn>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :disabled="disabledButton"
              @click="goToForm()"
            >
              {{ $t('buttons.add') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

import WAREHOUSE_TYPE from '@/constants/warehouse/warehouseType';

export default {
    name: 'AddWarehouseDialog',
    props: {
        visible: {
            default: false,
            type: Boolean
        },
        title: {
            default: ''
        },
        warehouseType: {
            required: true,
            type: Number
        }
    },
    data () {
        return {
            dialog: false,
            provinces: [],
            rejons: [],
            selectedProvinceId: null,
            WAREHOUSE_TYPE
        };
    },
    computed: {
        avaliableWioStructs () {
            return this.$store.getters['defaultApi/getAvailableWioStructs'];
        },
        regionalWarehouse () {
            return this.warehouseType === this.WAREHOUSE_TYPE.REGIONAL;
        },
        supportingWarehouse () {
            return this.warehouseType === this.WAREHOUSE_TYPE.SUPPORTING;
        },
        disabledButton () {
            if (this.regionalWarehouse && this.selectedRejon === null) {
                return true;
            } else if (this.supportingWarehouse && this.selectedProvince === null) {
                return true;
            } else {
                return false;
            }
        },
        ...mapFields('warehouses', ['selectedProvince', 'selectedRejon'])
    },
    watch: {
        visible (val) {
            this.dialog = val;
        },
        dialog () {
            if (!this.dialog) {
                this.$emit('close', false);
            } else {
                this.getProvinces();
            }
        },
        avaliableWioStructs: {
            handler () {
                this.getProvinces();
            },
            deep: true,
            immediate: true
        },
        selectedProvinceId: {
            handler (val) {
                if (val !== null) {
                    this.getRejons(val);
                }
            }
        }
    },
    methods: {
        getProvinces () {
            this.clearData();
            this.avaliableWioStructs.forEach((el) => {
                this.provinces.push(el.province);
            });
            if (this.provinces.length === 1) {
                this.selectedProvinceId = this.provinces[0].province_id;
                this.getRejons(this.selectedProvinceId);
            }
        },
        getRejons (val) {
            const province = this.avaliableWioStructs.find((el) => el.province.province_id === val);
            this.selectedProvince = province.province;
            this.rejons = [];
            province.wio_structs.forEach((k) => {
                this.rejons.push(k);
            });
        },
        clearData () {
            this.provinces = [];
            this.rejons = [];
            this.selectedProvince = null;
            this.selectedProvinceId = null;
            this.selectedRejon = null;
        },
        closeDialog () {
            this.selectedProvince = null;
            this.selectedRejon = null;
            this.selectedProvinceId = null;
            this.dialog = false;
        },
        goToForm () {
            this.dialog = false;
            let name = '';
            name = this.warehouseType === 1 ? 'warehouse-data' : 'supporting-warehouse-data';
            this.$store.dispatch('warehouses/setLocalIdToStorage', this.warehouseType);
            this.$router.push({ name });
        },
        filteredLocations (item, query) {
            return item.name.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1;
        }
    }
};
</script>

<style scoped></style>
